import { VoiceCallContext } from "@contexts/voiceCallContext"
import useCallSocket from "@customHooks/voice-call/use-call-socket"
import { CallRecive, useVoiceCall } from "@customHooks/voice-call/use-voice-call"
import { setVoiceAlert } from "@redux/slices/voice-call/voice-alert.slice"
import { setCurrentCall } from "@redux/slices/voice-call/voice-call.slice"
import { RootState } from "@redux/store"
import { deleteVoiceCallStartData } from "@services/voice-call/voiceCallService"
import { useContext, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

const VoiceCallManager = () => {
    const { expired, resetStates } = useContext(VoiceCallContext)
    const { leaveCall } = useVoiceCall()

    const currentCall = useSelector((state: RootState) => state.voiceCall)
    const { emitSocketEvent } = useCallSocket()
    const dispatch = useDispatch()

    const leave = () => {
        const data = currentCall.call as CallRecive
        if(!data) return

        emitSocketEvent("cancel_call", {
            name: data.name,
            id: data.id,
            token: data.token,
            room: data.room,
            nameEmit: data.nameEmit,
        })

        leaveCall(currentCall.audioTrack)
        const listener = {
            username: null,
            newCall: false
        }
        dispatch(setVoiceAlert(listener))
        
        emitSocketEvent("leave_call", {
            name: data.name,
            id: data.id,
            token: data.token,
            room: data.room,
            idEmit: data.idEmit,
        })

        deleteVoiceCallStartData(data.room)
            .then(() => console.debug(`Voice call room ${data.room} deleted`))
            .catch(err => console.error(`Could not delete number for room ${data.room}`, err))

        dispatch(setCurrentCall(undefined))
    }

    useEffect(() => {
        if(!expired) return
        leave()
        resetStates()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expired, resetStates])

    return null
}

export default VoiceCallManager
